import type { OrgModelRecord, OrgModelType } from "@/app/providers/services";

export type FormMode = "create" | "edit" | "view";

export const TYPE_OPTIONS: OrgModelType[] = [
  "parent",
  "approver",
  "member",
  "delegate",
  "resolvedApprover",
  "hierarchySummary",
  "hierarchyIssue",
];

export const SOURCE_OPTIONS = ["direct", "computed", "override"] as const;

export type FormState = {
  externalId: string;
  type: OrgModelType;
  subjectType: string;
  subjectId: string;
  relatedId: string;
  validFrom: Date | null;
  validTo: Date | null;
  level: string;
  source: "" | (typeof SOURCE_OPTIONS)[number];
};

export type ListFilters = {
  type: "" | OrgModelType;
  subjectType: string;
  subjectId: string;
  relatedId: string;
  level: string;
};

export type RebuildProgress = {
  phase: string;
  message: string;
  percent: number;
  counts?: Record<string, unknown>;
  updated: number;
};

export type RebuildJobStatus = "queued" | "completed" | "failed";

export type RebuildJobState = {
  id: string;
  status: RebuildJobStatus;
  progress?: RebuildProgress;
  message?: string;
};

export type GraphExpandDirection = "outgoing" | "incoming";

export type OrgModelRecordNodeData = {
  record: OrgModelRecord;
};

export type OrgModelEntityNodeData = {
  entityType: string;
  entityId: string;
  entityLabel: string;
  expandingIncoming: boolean;
  expandingOutgoing: boolean;
  onExpandIncoming: (entityType: string, entityId: string) => void;
  onExpandOutgoing: (entityType: string, entityId: string) => void;
};

export type OrgModelGraphProps = {
  selectedRecord?: OrgModelRecord | null;
  title?: string;
  emptyMessage?: string;
  onClear?: () => void;
};
